import { render, staticRenderFns } from "./DashboardGraphs.vue?vue&type=template&id=23c539fb&scoped=true&"
import script from "./DashboardGraphs.vue?vue&type=script&lang=js&"
export * from "./DashboardGraphs.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGraphs.vue?vue&type=style&index=0&id=23c539fb&scoped=true&lang=css&"
import style1 from "./DashboardGraphs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c539fb",
  null
  
)

export default component.exports